import React from 'react'

const MAPS_EMBED_SCRIPT_URL = `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_EMBED_KEY}`

const MapPreview = ({ address }) => {
  return (
    <iframe
      frameBorder="0"
      height="150"
      src={`${MAPS_EMBED_SCRIPT_URL}&q=${address}&zoom=14`}
      title="Address Preview"
      width="100%"
    ></iframe>
  )
}

export default MapPreview
